import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import ('../views/StartPage.vue')
  },
  {
    path: '/edit',
    component: () => import ('../views/EditPage.vue')
  },
  {
    path: '/send',
    component: () => import ('../views/SendPage.vue')
  },
  {
    path: '/demoSlides',
    component: () => import ('../views/DemoSlidesPage.vue')
  },
  {
    path: '/scans',
    component: () => import ('../views/MyScansPage.vue')
  },
  {
    name: "ScanDetail",
    path: '/scans/:id',
    component: () => import ('../views/ScanDetailPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
